/*
 * @Author: lihaitao
 * @Date: 2020-05-16 10:06:57
 * @Last Modified by: lihaitao
 * @Last Modified time: 2020-06-02 16:10:08
 * @Desc 对象存储路径（key）管理方案
 */

// 公共配置
interface Config {
  account: string;
  uuid: string;
}

/**
 * 获取营销资料 key
 * @param account 公司帐号
 * @param scence 场景：H5,article etc
 * @param fileName 文件名
 * @param uuid 唯一 id，用于追踪上传文件，保证文件是从系统上传
 */
function getMaterial (account: string, scence: string, fileName: string, uuid: string) {
  return `/${account}/material/${scence}/${uuid}/${fileName}`
}

/**
 * 获取普通素材 key
 * @param account 公司帐号
 * @param scence 场景：H5,article etc
 * @param fileName 文件名
 * @param uuid 唯一 id，用于追踪上传文件，保证文件是从系统上传
 */
function getPlain (account: string, scence: string, fileName: string, uuid: string) {
  return `/${account}/material/${scence}/${uuid}/${fileName}`
}

/**
 * 获取普通素材 key
 * @param account 公司帐号
 * @param scence 场景：H5,article etc
 * @param fileName 文件名
 * @param uuid 唯一 id，用于追踪上传文件，保证文件是从系统上传
 */
function getWXMP (account: string, scence: string, fileName: string, uuid: string) {
  return `/${account}/material/${scence}/${uuid}/${fileName}`
}

/**
 * 获取对象存储 key, 这里是为了限制对象存储的上传路径，方便管理
 * @param scence 场景值
 * @param fileName 文件名
 * @param config 公共配置
 */
export function keyDustessCloud (scence: string, fileName: string, config: Config) {
  const keyMap: any = {
    // 营销资料场景
    H5: getMaterial(config.account, scence, fileName, config.uuid),
    article: getMaterial(config.account, scence, fileName, config.uuid),
    brochure: getMaterial(config.account, scence, fileName, config.uuid),
    case: getMaterial(config.account, scence, fileName, config.uuid),
    form: getMaterial(config.account, scence, fileName, config.uuid),
    cof: getMaterial(config.account, scence, fileName, config.uuid),
    poster: getMaterial(config.account, scence, fileName, config.uuid),
    'video-markting': getMaterial(config.account, scence, fileName, config.uuid),
    // 普通素材
    image: getPlain(config.account, scence, fileName, config.uuid),
    video: getPlain(config.account, scence, fileName, config.uuid),
    file: getPlain(config.account, scence, fileName, config.uuid),
    // 官方模板库
    template: `/system/material/${scence}/${config.uuid}/${fileName}`,
    // 小程序
    card: `/${config.account}/wxmini/${scence}/${config.uuid}/${fileName}`,
    // 公众号管理
    massmsg: getWXMP(config.account, scence, fileName, config.uuid),
    autoreply: getWXMP(config.account, scence, fileName, config.uuid),
    // 商学院
    mba: `/${config.account}/${scence}/${config.uuid}/${fileName}`,
    // crm 商品管理
    goods: `/${config.account}/${scence}/${config.uuid}/${fileName}`
  }
  return keyMap[scence]
}
